import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1422ff92"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "record-icon" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Typography = _resolveComponent("Typography")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["recording-panel", _ctx.classRecordingPanel])
  }, [
    _hoisted_1,
    _createVNode(_component_Typography, {
      class: "text",
      fontType: "text",
      fontSize: "500",
      fontColor: "var(--sui-gray-200)"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t('recording.process')), 1)
      ]),
      _: 1
    }),
    (_ctx.showBtn)
      ? (_openBlock(), _createBlock(_component_Tooltip, {
          key: 0,
          class: "button-tooltip",
          text: _ctx.t('stop')
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "stop-button",
              mode: "flat",
              icon: { spriteUrl: '/image/videoconf-icons.svg', name: 'ic12-pause', color: '--sui-white', width: '12px', height: '12px'},
              size: "s",
              onClick: _ctx.requestStopRecording
            }, null, 8, ["icon", "onClick"])
          ]),
          _: 1
        }, 8, ["text"]))
      : _createCommentVNode("", true)
  ], 2))
}